module.exports = __webpack_public_path__ + "ffcf0c0e17df463ec431b21a304e3262.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/message_outbound/bound_type/inbound/rich_type/promo/targets/GRANDISPESE2_n.svg
 ** module id = 76
 ** module chunks = 0
 **/